var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-icon",class:{ open: _vm.open },attrs:{"role":"button","alt":"Menu"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{attrs:{"alt":"Menu"}})])}
var staticRenderFns = []

export { render, staticRenderFns }